import { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import { ReactComponent as HelpIconSvg } from "./icons/helpIcon.svg";

import styles from "./styles.module.scss";

export type HelpIconProps = HtmlHTMLAttributes<HTMLDivElement>

export const HelpIcon = memo(forwardRef<HTMLDivElement, HelpIconProps>(({ className, ...props }, ref) => {
  return (
    <div ref={ref} className={classNames(styles.root, className)} {...props}>
      <HelpIconSvg />
    </div>
  );
}));